import React from "react"
import types from "prop-types"
import { ScheduledTaskReportExportContextProvider } from "contexts/ScheduledTaskReportExportContext"
import { formSlugOptionShape, newTaskReportExportTaskReportShape } from "utils/propTypeShapes"
import ScheduledTaskReportExportForm from "views/ScheduledTaskReportExportForm"

// Editing renders the same form; the provider is what knows there is a record behind it.
const EditScheduledTaskReportExport = ({ scheduledTaskReportExport, submittableForms, taskReport }) => (
  <ScheduledTaskReportExportContextProvider
    scheduledTaskReportExport={scheduledTaskReportExport}
    submittableForms={submittableForms}
    taskReport={taskReport}
  >
    <ScheduledTaskReportExportForm />
  </ScheduledTaskReportExportContextProvider>
)

EditScheduledTaskReportExport.propTypes = {
  scheduledTaskReportExport: types.object.isRequired, // eslint-disable-line react/forbid-prop-types
  submittableForms: types.arrayOf(formSlugOptionShape).isRequired,
  taskReport: newTaskReportExportTaskReportShape.isRequired,
}

export default EditScheduledTaskReportExport
